var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"coach"},[_c('msp-app-bar'),_c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" Avviso ai coach ")]),_c('v-card-text',[_c('p',[_vm._v("Attualmente l'app mobile è disponibile solo per gli atleti.")]),_c('p',[_vm._v("Puoi utilizzare gli strumenti di CoachPeaking da PC.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }